export default __webpack_public_path__ + "static/icon-144x144-e638fcb97f650904fb8a4ee0941508c7.png";